export { default } from "./HighlightedQuote";
